import { render } from "./DatosInstalacion.vue?vue&type=template&id=4f5be3d8"
import script from "./DatosInstalacion.vue?vue&type=script&lang=js"
export * from "./DatosInstalacion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__